import React, { useEffect, useState } from "react";
import { useAuth } from "../../../context/authContext";

const MONTHS = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

export default function DashboardHeader({
  completionRate,
  pipelineTotal,
  loading,
  kpis,
}) {
  const { user } = useAuth();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(t);
  }, []);

  const greeting = (() => {
    const h = now.getHours();
    if (h < 12) return "Buenos días";
    if (h < 19) return "Buenas tardes";
    return "Buenas noches";
  })();

  const firstName = user?.name?.split(" ")[0] || "equipo";
  const dateLabel = `${now.getDate()} de ${MONTHS[now.getMonth()]} ${now.getFullYear()}`;
  const servicesMonth = kpis?.servicesThisMonth ?? 0;

  return (
    <header className="dash-hero">
      <p className="dash-hero-date">{dateLabel}</p>
      <h1 className="dash-hero-title">{greeting}, {firstName}</h1>
      <p className="dash-hero-sub">
        Panorama operativo · servicios e inventario
      </p>

      {!loading && (
        <div className="dash-hero-meta">
          <div className="dash-hero-stat">
            <span className="dash-hero-stat-val">{pipelineTotal?.toLocaleString("es-MX") ?? "—"}</span>
            <span className="dash-hero-stat-lbl">Servicios activos</span>
          </div>
          <div className="dash-hero-stat">
            <span className="dash-hero-stat-val">{completionRate ?? 0}%</span>
            <span className="dash-hero-stat-lbl">Completación</span>
          </div>
          <div className="dash-hero-stat">
            <span className="dash-hero-stat-val">{servicesMonth.toLocaleString("es-MX")}</span>
            <span className="dash-hero-stat-lbl">Este mes</span>
          </div>
        </div>
      )}
    </header>
  );
}
